/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/guiPatents/guiPatentsActions";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../../_metronic/_partials/controls";
import { GuiPatentEditForm } from "./GuiPatentEditForm";
import { useSubheader } from "../../../../../../_metronic/layout";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import { KTUtil } from "../../../../../../_metronic/_assets/js/components/util";
import KTLayoutQuickForm from "../../../../Admin/utils/quick-form";
import {GuideProfile} from "../../profile/GuideProfile";
import axios from "axios";

const initGuiPatent = {
  id: undefined,
  guideId: 0,
  patentRegNo: "",
  patentingOrg: "",
  patentTitle: "",
  patentDesc: "",
  uploadDoc: "",
};
export function GuiPatentEdit({
  history,
  match: {
    params: { id,gid },
  },
}) {
  useLayoutEffect(() => {
    KTUtil.ready(function() {
      KTLayoutQuickForm.init("kt_quick_form");
    });
  }, []);
  // Subheader
  const subheader = useSubheader();

  // Tabs
  // const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  // const layoutDispatch = useContext(LayoutContext.Dispatch);
  const { actionsLoading, guiPatentForEdit } = useSelector(
    (state) => ({
      actionsLoading: state.guiPatents.actionsLoading,
      guiPatentForEdit: state.guiPatents.guiPatentForEdit,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchGuiPatent(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = id ? "" : "New Guide Patent";
    if (guiPatentForEdit && id) {
      _title = `Edit Guide Patent`;
    }

    setTitle(_title);
    subheader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guiPatentForEdit, id]);

  const saveGuiPatent = (values) => {
    if (!id) {
      dispatch(actions.createGuiPatent(values)).then(() =>
        backToGuiPatentsList()
      );
    } else {
      dispatch(actions.updateGuiPatent(values)).then(() =>
        backToGuiPatentsList()
      );
    }
  };

  const btnRef = useRef();
  const saveGuiPatentClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const id1 = id===undefined?'':id
  const GuideUrl = `${process.env.REACT_APP_API_URL}/api/GuiPatent/${id1}`;

  const [guide, setGuide] = useState([]);

  useEffect(() => {
    const getGuide = async () => {
      const response = await axios.get(GuideUrl);
      setGuide(response.data);
    };
    getGuide();
  }, [setGuide,GuideUrl]);


  const GuideId = gid?gid:guide.guideId; 
 
  initGuiPatent.guideId=GuideId;


  const backToGuiPatentsList = () => {
    history.push(`/guide/guideprofile`);
  };

  return (
    <div>
      <GuideProfile />
      <div
        id="kt_quick_form"
        className="offcanvas offcanvas-right offcanvas offcanvas-on offcanvas-sm"
      >
        <div className="offcanvas-content pr-5 mr-n5">
          <Card>
            {actionsLoading && <ModalProgressBar />}
            <CardHeader title={title}>
              <CardHeaderToolbar>
                <button
                  type="button"
                  onClick={backToGuiPatentsList}
                  className="btn btn-light"
                >
                  <i className="fa fa-times"></i>
                  Close
                </button>
                {/* <button className="btn btn-light ml-2">
                    <i className="fa fa-redo"></i>
                    Reset
                  </button> */}
                <button
                  type="submit"
                  className="btn btn-primary ml-2"
                  onClick={saveGuiPatentClick}
                >
                  Save
                </button>
              </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
              {!actionsLoading && (
                <GuiPatentEditForm
                  actionsLoading={actionsLoading}
                  guiPatent={guiPatentForEdit || initGuiPatent}
                  btnRef={btnRef}
                  saveGuiPatent={saveGuiPatent}
                />
              )}
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
